import {
  AUTOMATION_TEMPLATES,
  filterAutomationTemplates,
  type AutomationTemplateCategoryFilter,
  type AutomationTemplateDefinition,
} from "./automationTemplates";
import { CreateAutomationTemplateCatalog } from "./CreateAutomationTemplateCatalog";

export function AutomationTemplatePane(props: {
  readonly category: AutomationTemplateCategoryFilter;
  readonly mobileVisible: boolean;
  readonly query: string;
  readonly selectedTemplate: AutomationTemplateDefinition | null;
  readonly onBlank: () => void;
  readonly onCategoryChange: (category: AutomationTemplateCategoryFilter) => void;
  readonly onQueryChange: (query: string) => void;
  readonly onSelect: (template: AutomationTemplateDefinition) => void;
}) {
  return (
    <CreateAutomationTemplateCatalog
      category={props.category}
      mobileVisible={props.mobileVisible}
      query={props.query}
      selectedKey={props.selectedTemplate?.key ?? null}
      templates={filterAutomationTemplates(AUTOMATION_TEMPLATES, props.category, props.query)}
      onBlank={props.onBlank}
      onCategoryChange={props.onCategoryChange}
      onQueryChange={props.onQueryChange}
      onSelect={props.onSelect}
    />
  );
}
